import SSEManager, { install } from './manager'

export default {
  install
}

export { SSEManager, install }
